<div class="truck-overview-action-bar">
  <div class="group">
    <div class="buttons">
      <button mat-icon-button (click)="registerTruck()"
        [matTooltip]="'register' | translate: ['tmc.visit.overview.trucks.action.register',translationService.language]">
        <sc-icon iconClass="fa-plus"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="editTruck()" [disabled]="!editTruckEnabled"
        [matTooltip]="'edit ' | translate: ['tmc.visit.overview.trucks.action.edit',translationService.language]">
        <sc-icon iconClass="fa-edit"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="leave()"
        [matTooltip]="'Abmelden' | translate: ['tmc.visit.overview.trucks.action.leave',translationService.language]"
        [disabled]="!leaveTruckEnabled">
        <sc-icon iconClass="fa-door-closed"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-icon-button (click)="showGcCase()" [disabled]="!showGcCaseEnabled"
        *ngIf="configurationService.isEnabled('feature.globalconnect', true)"
        [matTooltip]="'QC-Case' | translate: ['tmc.visit.overview.action.showGcCase', translationService.language]">
        <sc-icon iconClass="fa-mobile-android-alt"></sc-icon>
      </button>
    </div>
  </div>
</div>